import React, { useEffect, useState } from "react";
import styled from "styled-components";
import SearchBar from "../molecules/Dashboard/Navbar/Searchbar";
import ProfileSection from "../molecules/Dashboard/Navbar/ProfileSection";
import BranchSwitcher from "../molecules/Dashboard/Navbar/BranchSwitcher";
import MobileSidebar from "./MobileSidebar";
import { getWhiteLableObject } from "../../config/whitelable";
import { device } from "../atoms/Utlis/media";
import { useLocation, Link } from "react-router-dom";

const Navbar: React.FC = () => {
  const [isSearchbarVisible, setIsSearchbarVisible] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;

  const exactPaths = ["/dashboard"];
  const prefixPaths = [
    "/dashboard/payments",
    "/dashboard/packages/all",
    "/dashboard/packages/request",
    "/dashboard/user/transactions",
    "/dashboard/quotation",
    "/dashboard/orders",
    "/dashboard/leads",
  ];

  useEffect(() => {
    const normalizedPath = pathname.length > 1 ? pathname.replace(/\/$/, "") : pathname;

    const isExactMatch = exactPaths.includes(normalizedPath);
    const isPrefixMatch = prefixPaths.some(
      (path) => normalizedPath === path || normalizedPath.startsWith(`${path}/`)
    );

    setIsSearchbarVisible(isExactMatch || isPrefixMatch);
  }, [pathname]);

  return (
    <NavbarShell>
      <NavbarBar>
        <NavbarGlow aria-hidden />
        <NavbarLeft>
          <MobileLogoLink to="/dashboard">
            <MobileLogo
              src={`/logos/${getWhiteLableObject().logo.filename}`}
              alt={getWhiteLableObject().name}
            />
          </MobileLogoLink>
        </NavbarLeft>

        <NavbarCenter>{isSearchbarVisible && <SearchBar />}</NavbarCenter>

        <NavbarRight>
          <BranchSwitcher />
          <ProfileSection />
          <MobileSidebar />
        </NavbarRight>
      </NavbarBar>
    </NavbarShell>
  );
};

export default Navbar;

const NavbarShell = styled.header`
  flex-shrink: 0;
  padding: 16px 24px 12px;
  position: relative;
  z-index: 100;

  @media ${device.tablet} {
    padding: 12px 16px 10px;
  }
`;

const NavbarBar = styled.div`
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 16px;
  min-height: 62px;
  padding: 10px 16px 10px 18px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 10px 28px rgba(23, 23, 23, 0.05);
  backdrop-filter: blur(10px);
  overflow: visible;

  @media ${device.tablet} {
    gap: 12px;
    padding: 10px 12px;
    min-height: 56px;
  }
`;

const NavbarGlow = styled.div`
  pointer-events: none;
  position: absolute;
  top: -40px;
  right: 80px;
  width: 160px;
  height: 160px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(201, 77, 170, 0.1) 0%,
    rgba(255, 201, 81, 0.08) 45%,
    transparent 70%
  );
`;

const NavbarLeft = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

const MobileLogoLink = styled(Link)`
  display: none;

  @media ${device.tablet} {
    display: flex;
    align-items: center;
  }
`;

const MobileLogo = styled.img`
  width: 44px;
  height: 44px;
  object-fit: contain;
  border-radius: 12px;
`;

const NavbarCenter = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: start;
  justify-content: start;

  @media ${device.tablet} {
    justify-content: stretch;
  }
`;

const NavbarRight = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  margin-left: auto;
  position: relative;
  z-index: 2;

  @media ${device.tablet} {
    gap: 8px;
  }
`;
